import React, { useCallback, useEffect, useState } from 'react';
import TrialActivationPopup from './TrialActivationPopup';
import {
    TRIAL_ACTIVATION_POPUP_EVENT,
    clearTrialActivationPopup,
    peekTrialActivationPopup,
} from '../../utils/subscriptionTrial';

/**
 * Single owner for the trial-success Dialog. Lives next to the router so
 * onboarding remounts (packages → continue-to-settings, StrictMode, refetch)
 * cannot open a second overlay.
 */
const TrialActivationPopupHost = () => {
    const [trialPopup, setTrialPopup] = useState(() => peekTrialActivationPopup());

    useEffect(() => {
        const sync = () => {
            setTrialPopup(peekTrialActivationPopup());
        };
        window.addEventListener(TRIAL_ACTIVATION_POPUP_EVENT, sync);
        return () => window.removeEventListener(TRIAL_ACTIVATION_POPUP_EVENT, sync);
    }, []);

    const handleClose = useCallback(() => {
        clearTrialActivationPopup();
        setTrialPopup(null);
    }, []);

    return (
        <TrialActivationPopup
            open={Boolean(trialPopup)}
            startDate={trialPopup?.startDate}
            endDate={trialPopup?.endDate}
            onClose={handleClose}
        />
    );
};

export default TrialActivationPopupHost;
